import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { assessmentComparisonSearchSchema } from '@/pages/assessment/lib/comparisonSearchSchema';
import { AssessmentComparisonAiPage } from '@/pages/assessment/ui/AssessmentComparisonAiPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

// 年度明細（base）と共通の sort/order/amount_unit に、差分固有の accumulationId を追加する。
const querySchema = assessmentComparisonSearchSchema.extend({
  // ai実行対象のID
  accumulationId: z.string().nullish(),
});

export const Route = createFileRoute('/_protected/assessment/$assessmentId/diff')({
  component: AssessmentComparisonAiPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      customSchema: querySchema,
      defaultValues: undefined,
      usePaginationSchema: false,
    }),
});
